import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { ExtensionViewTypeValue } from 'src/legacy/components/Settings/ExtensionsPage/ExtensionViewType';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import * as Colors from 'src/theme/colors';

const useStyles = makeStyles()(() => ({
  helperLabel: {
    color: Colors.GraySmall,
  },
}));

interface ExtensionEmbedFieldLabelProps {
  newLineHelper?: boolean;
  extensionViewType?:
    | ExtensionViewTypeValue.EMBED
    | ExtensionViewTypeValue.LINK;
}

export const ExtensionEmbedFieldLabel: React.FC<
  ExtensionEmbedFieldLabelProps
> = ({ newLineHelper = false, extensionViewType }) => {
  const { classes } = useStyles();

  const labelDescription = React.useMemo(() => {
    if (extensionViewType === ExtensionViewTypeValue.LINK) {
      return 'Can be a public URL';
    }

    return 'Can be a public URL or iFrame';
  }, [extensionViewType]);

  return (
    <div>
      <BaseTypography fontType="13Medium" component="span">
        Content
      </BaseTypography>
      <BaseTypography component="span" className={classes.helperLabel}>
        {newLineHelper ? <br /> : ' - '}
        {labelDescription}
      </BaseTypography>
    </div>
  );
};
